"use client";
import { decode } from "html-entities";

const extractScripts = (description: string) => {
  if (!description) return { html: "", scripts: [] };

  const decodedDescription = decode(description);

  const regex = /<script[^>]*>([\s\S]*?)<\/script>/gi;
  const matches = [...decodedDescription.matchAll(regex)];

  const scripts: any[] = [];
  matches.forEach((match) => {
    const src = match[0].replace('src="/', 'src="https:/').match(/src=["']([^"']+)["']/);

    if (src) {
      scripts.push({ content: "", src: src[1] });
    } else {
      scripts.push({ content: match[1], src: "" });
    }
  });

  const contentWithoutStyleOrScript = decodedDescription.replace(regex, "");
  return { html: contentWithoutStyleOrScript, scripts };
};
export default extractScripts;
